/**
 * @file SessionEndDialog.tsx
 * @copyright 2023 Boston Scientific Corporation
 * ********************************************************************************************************************
 * Copyright © 2023 Boston Scientific Corporation All rights reserved.
 *
 * This file and its contents are a product of Boston Scientific Corporation.  All software distributed by Boston
 * Scientific Neuromodulation is done so under a software license.  This file may not be copied or modified without
 * execution of the appropriate software license agreement with Boston Scientific Neuromodulation or explicit written
 * permission of Boston Scientific Neuromodulation.
 *
 * This file is provided as is, with no warranties of any kind including the warranties of design, merchantability and
 * fitness for a particular purpose, or arising from a course of dealing, usage or trade practice.
 *
 * Boston Scientific Neuromodulation shall have no liability with respect to the infringement of copyrights, trade
 * secrets or any patents by this file or any part thereof.
 *
 * In no event will Boston Scientific Neuromodulation be liable for any lost revenue or profits or other special,
 * indirect and consequential damages, even if Boston Scientific has been advised of the possibility of such damages,
 * as a result of the usage of this file and software for which this file is a part.
 * ********************************************************************************************************************
 *
 */
import React from "react";
import {  Button, Grid, Paper, Stack } from "@mui/material";
import { Container, ThemeProvider } from "@mui/system";
import "./../css/Common.css";
import { BaseComponent } from "../../home/base/BaseComponent";
import { Img } from "./AppImg";
import { DeleteDialogButton } from "../../home/admin/themes/AddNewAdminDialogTheme";
import { LogoutMessage } from "../../utils/AppConstant";

/**
 * A type of Component state
 */
type CompState = {
    clinicId: string
};

/**
 * An interface definition for Component Props
 */
interface Props {
    onSessionDialogDismissed: any,
}

/**
 * A class definition for component SessionEndDialog
 */
export class SessionEndDialog extends BaseComponent<Props, CompState> {

    constructor(props: Props) {
        super(props)
    }

    /**
     * Dismisses the dialog
     */
    private dismissDialog = () => {
        this.props.onSessionDialogDismissed();
    }


    render() {

        return <>
                    <div className="SessionEndBox">
                        <Paper elevation={0}>
                            <Grid container spacing={0} sx={{padding: "0"}}>
                                <Grid item xs={12} sm={12}>
                                            <Img alt="complex" src="/../warning.svg" className="DeleteIcon"/>
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                        <p className="RecordDeleteDescription">
                                          {LogoutMessage}
                                        </p>
                                </Grid>                       
                            </Grid>
                            <Container>
                            <Stack
                                        direction="row"
                                        justifyContent="flex-end"
                                        alignItems="flex-end"
                                        spacing={2}
                                        >
                                        <ThemeProvider theme={DeleteDialogButton}>
                                            <Button variant="contained" onClick={this.dismissDialog} size="small"
                                                disableElevation className="ActivateNewUserBtn">
                                                OK
                                            </Button>
                                        </ThemeProvider>
                            </Stack>
                        </Container>
                    </Paper>
                </div>
        </>
    }
}